import LegacyFooter from '../Footer';
import type { FooterProps } from '../Footer';
import { FOOTER_VARIANT_COMPONENTS } from './registry';

export type { FooterProps };

/**
 * The storefront footer, dispatched by Look variant. Variants with their own
 * component (registry.ts) render it; everything else renders the original
 * Footer.tsx. `minimal` chrome always wins (layout_chrome is a site-level
 * mode the legacy footer owns). A wrapper, not an early return, so a runtime
 * variant switch (Design Sandbox preview) never changes a component's hook
 * order.
 */
export default function Footer(props: FooterProps = {}) {
  const variant = props.variant;
  const Custom = !props.minimal && variant ? FOOTER_VARIANT_COMPONENTS[variant] : undefined;
  if (Custom) return <Custom {...props} />;
  return <LegacyFooter {...props} />;
}
